// extracted by mini-css-extract-plugin
module.exports = {"filters":"AddShop_filters__2u5qs","editFields":"AddShop_editFields__3AgO8","padding":"AddShop_padding__1o8YS"};